export const makeNumPinUrl = (
  num: number,
  fill = '#FF673E',
  textColor = '#FFFFFF',
  width = 32,        // ← 원하는 크기
  height = 42,
) => {
  const svg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 40 52">
    <path d="M20 0C9 0 0 9 0 20c0 14 20 32 20 32s20-18 20-32C40 9 31 0 20 0z" fill="${fill}"/>
    <text x="20" y="26" text-anchor="middle" font-size="16" font-family="Arial" font-weight="700"
          fill="${textColor}" dominant-baseline="middle">${num}</text>
  </svg>`;
  const encoded =
    typeof window === 'undefined'
      ? Buffer.from(svg).toString('base64')
      : btoa(svg);
  return `data:image/svg+xml;base64,${encoded}`;
};
